export enum CompanyUserNotification {
  CONNECTION_COMPLETED = 'connection-completed',
}
